import keycloakService from '../../keycloak_service';
import { postToSinatra } from '../api_utils';

export const measureStorageSizeForOrchestrations = (queryParams) => {
  const [, orchestrations] = queryParams;
  const body = JSON.stringify({ orchestrations, confirm_delete: false });

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToSinatra('v1/api/orchestration/delete_orchestrations', fetchOptions)
}

export const deleteOrchestrations = (orchIds = []) => {
  const body = JSON.stringify({
    orchestrations: orchIds,
    confirm_delete: true,
  });

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToSinatra('v1/api/orchestration/delete_orchestrations', fetchOptions)
}

export default deleteOrchestrations;
